module.exports = __webpack_public_path__ + "img/pwa-role-bind.3e8d0265.png";